import { createFormDataRequest } from "@/helpers/FormHelpers";
import { toCalendarEvent } from "@/helpers/MeetingHelpers";
import Meeting, {
  MeetingFilters,
  MeetingFormSend,
  StandaloneMeetingFormSend,
} from "@/interfaces/Meeting";
import api from "@/services/api";
import { EventSourceInput } from "@fullcalendar/core";

export const meetingsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMeetings: build.query<EventSourceInput, MeetingFilters>({
      query: (data) => {
        const params = createFormDataRequest(data);
        return { url: `/meetings`, params };
      },
      transformResponse: (response: Meeting[]) => response.map(toCalendarEvent),
      providesTags: [{ type: "Meetings", id: "LIST" }],
    }),
    storeMeeting: build.mutation<Meeting, StandaloneMeetingFormSend>({
      query: (body) => ({ url: `/meetings`, method: "POST", body }),
      invalidatesTags: [
        { type: "CommercialBooking", id: "LIST" },
        { type: "Meetings", id: "LIST" },
        { type: "MontageMeetings", id: "LIST" },
      ],
    }),
    // Changement d'heure d'un rendez-vous sans entreprise : pas de route sous
    // /companies, et PUT /meetings/:id applique la même règle de créneau.
    updateMeeting: build.mutation<
      Meeting,
      [
        string,
        Pick<MeetingFormSend, "startAt" | "bookingProtocol" | "proposalToken">,
      ]
    >({
      query: ([id, body]) => ({ url: `/meetings/${id}`, method: "PUT", body }),
      invalidatesTags: (_result, _error, [id]) => [
        { type: "CommercialBooking", id: "LIST" },
        { type: "Meetings", id: "LIST" },
        { type: "MontageMeetings", id },
        { type: "MontageMeetings", id: "LIST" },
      ],
    }),
    destroyMeeting: build.mutation<void, string>({
      query: (id) => ({ url: `/meetings/${id}`, method: "DELETE" }),
      invalidatesTags: (_result, _error, id) => [
        { type: "CommercialBooking", id: "LIST" },
        { type: "Meetings", id: "LIST" },
        { type: "MontageMeetings", id: "LIST" },
        { type: "MontageMeetings", id },
      ],
    }),
  }),

  overrideExisting: true,
});

export const {
  useGetMeetingsQuery,
  useDestroyMeetingMutation,
  useStoreMeetingMutation,
  useUpdateMeetingMutation,
} = meetingsApi;
